/*!
* v-offline v3.1.0
* (c) 2022 Vinayak Kulkarni
* @license MIT
*/
import { defineComponent, ref, computed, onBeforeUnmount, h } from 'vue';

var ping = {exports: {}};

/**
 * Creates a Ping instance.
 * @returns {Ping}
 * @constructor
 */

(function (module, exports) {
var Ping = function(opt) {
    this.opt = opt || {};
    this.favicon = this.opt.favicon || "/favicon.ico";
    this.timeout = this.opt.timeout || 0;
    this.logError = this.opt.logError || false;
};

/**
 * Pings source and triggers a callback when completed.
 * @param {string} source Source of the website or server, including protocol and port.
 * @param {Function} callback Callback function to trigger when completed. Returns error and ping value.
 * @returns {Promise|undefined} A promise that both resolves and rejects to the ping value. Or undefined if the browser does not support Promise.
 */
Ping.prototype.ping = function(source, callback) {
    var promise, resolve, reject;
    if (typeof Promise !== "undefined") {
        promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
    }

    var self = this;
    self.wasSuccess = false;
    self.img = new Image();
    self.img.onload = onload;
    self.img.onerror = onerror;

    var timer;
    var start = new Date();

    function onload(e) {
        self.wasSuccess = true;
        pingCheck.call(self, e);
    }

    function onerror(e) {
        self.wasSuccess = false;
        pingCheck.call(self, e);
    }

    if (self.timeout) {
        timer = setTimeout(function() {
            pingCheck.call(self, undefined);
    }, self.timeout); }


    /**
     * Times ping and triggers callback.
     */
    function pingCheck() {
        if (timer) { clearTimeout(timer); }
        var pong = new Date() - start;

        if (!callback) {
            if (promise) {
                return this.wasSuccess ? resolve(pong) : reject(pong);
            } else {
                throw new Error("Promise is not supported by your browser. Use callback instead.");
            }
        } else if (typeof callback === "function") {
            // When operating in timeout mode, the timeout callback doesn't pass [event] as e.
            // Notice [this] instead of [self], since .call() was used with context
            if (!this.wasSuccess) {
                if (self.logError) { console.error("error loading resource"); }
                if (promise) { reject(pong); }
                return callback("error", pong);
            }
            if (promise) { resolve(pong); }
            return callback(null, pong);
        } else {
            throw new Error("Callback is not a function.");
        }
    }

    self.img.src = source + self.favicon + "?" + (+new Date()); // Trigger image load with cache buster
    return promise;
};

{
    if (module.exports) {
        module.exports = Ping;
    }
}
}(ping));

var Ping = ping.exports;
var ping_js = Ping;

var Ping$1 = ping_js;

var script = defineComponent({
    name: 'VOffline',
    props: {
      onlineClass: {
        type: String ,
        required: false,
        default: '',
      },
      offlineClass: {
        type: String ,
        required: false,
        default: '',
      },
      pingUrl: {
        type: String ,
        required: false,
        default: 'https://google.com',
      },
    },
    emits: ['detected-condition'],
    setup(props, { slots, emit }) {
      // Local state
      const isOnline = ref(navigator.onLine || false);
      const events = ref(['online', 'offline', 'load']);
      const url = ref(props.pingUrl || 'https://google.com');

      // Local computed
      const wrapperClass = computed(() => {
        if (isOnline.value) {
          return typeof props.onlineClass === 'string' ? props.onlineClass : '';
        } else {
          return typeof props.offlineClass === 'string'
            ? props.offlineClass
            : '';
        }
      });

      /**
       * Created lifecycle hook
       */
      events.value.forEach((event) => window.addEventListener(event, check));

      /**
       * Before unmount lifecycle hook
       */
      onBeforeUnmount(() => {
        // Cleanup of the event listeners
        events.value.forEach((event) =>
          window.removeEventListener(event, check),
        );
      });

      // Local functions
      /**
       * Pings the URL and emits an
       * detected online/offline event.
       *
       * @returns {Promise<void>}
       */
      async function check() {
        const p = new Ping$1();
        try {
          const ping = await p.ping(url.value);
          if (ping || navigator.onLine) {
            isOnline.value = true;
            emit('detected-condition', isOnline.value);
          }
        } catch (error) {
          if (error || !navigator.onLine) {
            isOnline.value = false;
            emit('detected-condition', isOnline.value);
          }
        }
      }

      return () => h('div', { class: wrapperClass.value }, slots);
    },
  });

script.__file = "src/components/VOffline.vue";

const setVueInstance = (instance) => {
};

let installed = false;

const install = (
  instance,
) => {
  if (!installed) {
    setVueInstance(instance);
    instance.component('VOffline', script);
    installed = true;
  }
};

var install$1 = install;

export { script as VOffline, install$1 as default };
//# sourceMappingURL=v-offline.esm.js.map
